var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-layout",
    {
      attrs: {
        size: "narrow",
        title: _vm.Resources.BackerCenter.SectionPledgesAndOrdersHeader,
        "current-view": "pledges",
      },
    },
    [
      _c("filter-view", {
        attrs: {
          filters: _vm.pledgesAndOrdersFilters,
          "filter-list-title": _vm.Resources.Search.SearchFiltersHeader,
          "sort-list-title": _vm.Resources.Search.SearchProjectSortTitle,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              items,
              isProcessing,
              canLoadMore,
              loadMore,
              isLoadingMore,
            }) {
              return [
                isProcessing
                  ? _c(
                      "div",
                      {
                        staticClass: "_flexcol _gap-4 _gap-6--m _mt-2",
                        attrs: { "data-qa": "pledges-and-orders:Skeleton" },
                      },
                      _vm._l(3, function (s) {
                        return _c("backer-center-pledge-card-skeleton", {
                          key: `skeleton:${s}`,
                        })
                      }),
                      1
                    )
                  : _vm.hasOrders
                  ? [
                      _c(
                        "div",
                        { staticClass: "_flexcol _gap-4 _gap-6--m _mt-2" },
                        _vm._l(items, function (pledge) {
                          return _c(
                            "backer-center-pledge-card",
                            _vm._b(
                              {
                                key: pledge.orderID,
                                on: {
                                  "action-dismissed": _vm.onActionDismissed,
                                },
                              },
                              "backer-center-pledge-card",
                              pledge,
                              false
                            )
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      isLoadingMore
                        ? _vm._l(3, function (s) {
                            return _c("backer-center-pledge-card-skeleton", {
                              key: `skeleton:${s}`,
                            })
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      canLoadMore
                        ? _c("load-more-trigger", {
                            on: { "load-more": loadMore },
                          })
                        : _vm._e(),
                    ]
                  : _c(
                      "box",
                      { staticClass: "_mt-2" },
                      [
                        _c(
                          "empty-state",
                          {
                            attrs: {
                              title:
                                _vm.Resources.BackerCenter
                                  .PledgesAndOrdersEmptyStateHeader,
                              description:
                                _vm.Resources.BackerCenter
                                  .PledgesAndOrdersEmptyStateParagraph,
                              "data-qa": "pledges-and-orders:EmptyState",
                            },
                          },
                          [
                            _c(
                              "base-button",
                              {
                                attrs: {
                                  tag: "a",
                                  href: _vm.searchUrl,
                                  icon: "search",
                                  theme: "accent",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.Resources.BackerCenter
                                        .UpdatesFeedEmptyStateButtonLabel
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }